import React, { FunctionComponent, useState } from "react";
import { useDispatch } from "react-redux";
import { SpecialOffer } from "@/components/responsive/product/specialOffer/SpecialOffer";
import { ShowMoreButton } from "@/components/responsive/product/showMoreButton/ShowMoreButton";
import { RefundOffer } from "@/models/scope/productSheet/promotionalOffers/RefundOffer";
import { fetchBundleOffersListData } from "@/redux/reducers/responsive/product/promotionalOffersActions";

const DISPLAY_LIMIT = 2;

interface Props {
    refundOfferList: RefundOffer[],
    promotionalOffers: string,
    setLayerType: () => void,
}

export const RefundOffersBlock: FunctionComponent<Props> = ({
    refundOfferList,
    promotionalOffers,
    setLayerType,
}) => {
    const dispatch = useDispatch();
    const [isAllOffersDisplayed, setIsAllOffersDisplayed] = useState(false);

    const parsedPromotionalOffers = JSON.parse(promotionalOffers);
    const bundleOffersList = parsedPromotionalOffers && parsedPromotionalOffers['bundle_offers'] ? parsedPromotionalOffers['bundle_offers'] : [];
    const lotOffersList = parsedPromotionalOffers && parsedPromotionalOffers['lot_offers'] ? parsedPromotionalOffers['lot_offers'] : [];
    const isDatePassed = (endDate: string | Date): boolean => {
        const endDateObj = new Date(endDate);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return endDateObj < today;
    };
    const validBundleOffers = bundleOffersList.filter((offer: { end_date: string | Date }) => !isDatePassed(offer.end_date));
    const validLotOffers = lotOffersList.filter((offer: { end_date: string | Date }) => !isDatePassed(offer.end_date));
    let offerNumber = (refundOfferList?.length ?? 0) + validBundleOffers.length + validLotOffers.length;
    if (offerNumber == 0) return null;

    const clickOnItem = (bundleId: string) => {
        dispatch(fetchBundleOffersListData(bundleId));
        setLayerType();
    }
    
    return (
        <div className="offers-block">
            <p className="title-block">
                {offerNumber === 1
                    ? `1 offre spéciale`
                    : `${offerNumber} offres spéciales`}
            </p>
            <div className="details">
                {refundOfferList.map((refundOffer, index) => {
                    const {
                        odrTitle,
                        odrFinishDate,
                        odrDescription,
                        odrId,
                        odrUrlInfo
                    } = refundOffer;
                    return (
                        <div
                            key={odrId}
                            className={
                                index >= DISPLAY_LIMIT && !isAllOffersDisplayed
                                    ? "offer hide-display"
                                    : "offer"
                            }
                        >
                            <SpecialOffer
                                title={odrTitle}
                                description={odrDescription}
                                endDate={odrFinishDate}
                                isItemClickable={Boolean(odrUrlInfo)}
                                urlInfo={odrUrlInfo}
                            />
                        </div>
                    );
                })}
                {[...bundleOffersList, ...lotOffersList].map((offer, index) => {
                    const {
                        end_date,
                        description,
                        bundle_id,
                        lot_id
                    } = offer;
                    const isBundle = Boolean(bundle_id);
                    if (isDatePassed(end_date)) {
                        return null;
                    }
                    return (
                        <div
                            key={bundle_id || lot_id}
                            className={
                                index >= (DISPLAY_LIMIT - refundOfferList.length) && !isAllOffersDisplayed
                                    ? "offer hide-display"
                                    : "offer"
                            }
                        >
                            <SpecialOffer
                                title={description}
                                description={null}
                                endDate={end_date}
                                isItemClickable={isBundle}
                                urlInfo={null}
                                handleClick={isBundle ? () => clickOnItem(bundle_id) : undefined}
                            />
                        </div>
                    );
                })}
            </div>
            {offerNumber > DISPLAY_LIMIT && (
                <ShowMoreButton
                    handleClick={() => setIsAllOffersDisplayed(!isAllOffersDisplayed)}
                    isInitialArrowDown={true}
                >
                    <p>Voir toutes les offres</p>
                </ShowMoreButton>
            )}
        </div>
    );
};